/* eslint-disable no-console */

import CONFIG from 'Config/settings';

export default class OWShoppingListApiClientMock {
  constructor() {
    this.apiHost = CONFIG.API.SHOPPING_LIST.HOST;
  }

  // eslint-disable-next-line class-methods-use-this
  getNumOfShoppingLists() {
    console.log(
      'OWShoppingListApiClient mock API getNumOfShoppingLists called'
    );
    return Promise.resolve('3');
  }
}
